import * as Sentry from "@sentry/angular";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


// Disable sentry during development
// Sentry.init({
//     dsn: "https://afcffd6087f848bd94b3c6689080d783@o300968.ingest.us.sentry.io/3589004",
//     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//     tracesSampleRate: 1,
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1,
//     enableLogs: true
// })


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
